var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('card',[_c('radio-list',{attrs:{"items":_vm.navs},model:{value:(_vm.nav),callback:function ($$v) {_vm.nav=$$v},expression:"nav"}}),_vm._l((_vm.navs),function(n,k){return [(n.id === _vm.nav)?_c(n.id,{key:k,tag:"component"}):_vm._e()]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }